import { memo, useEffect, useState } from "react";
import styles from "./congratulationsPageSell.module.scss";
import { FormControl, InputLabel, OutlinedInput, CircularProgress } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { FormErrors, CongratulationsPageSellProps, FormData } from "../../../interfaces/pages";
import ModalPayment from "../../LinzeCheck/EntryPoint/components/ModalPayment";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { useToast } from "../../../helpers/hooks";
import ButtonShared from "../../../components/Button";
import { images } from "../../../constants/images";

type FormField = keyof FormErrors;

const CongratulationsPageSell: React.FC<CongratulationsPageSellProps> = ({ user, getLinkPayment, linkPayment, getDataPayment, dataPayment, getPaymentProcess, publicationInfo, payment }) => {
    const navigate = useNavigate(); 
    const location = useLocation();
    
    const { publication } = location.state || {};
    
    const [formData, setFormData] = useState<FormData>({
        name: '',
        lastname: '',
        email: '',
        rut: '',
        phone: '',
        plate: ''
    });

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [hasCalledPayment, setHasCalledPayment] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [canAcquireReport, setCanAcquireReport] = useState(false);
    const isLoading = payment?.fetching === "loading";

    const handleSubmitCarInfo = () => {
        if (!getLinkPayment) return;
        
        const formattedPhone = user?.phone?.code && user?.phone?.number
            ? `${user.phone.code.replace('+', '')}${user.phone.number}`
            : user?.phone;
        
        const newFormData = {
            plate: publication.plate,
            price: 79999,
            name: user?.name,
            last_name: user?.last_name,
            legal_id: user?.legal_id,
            email: user?.email,
            phone: formattedPhone,
        };
        getLinkPayment(newFormData);
        
    };

    const handleGetUrl = () => {
        if (payment?.report?.report?._id && !hasCalledPayment ) {
            const newPaymentData = {
                paymentMethod: "paga-en-linea",
                total_amount: 7990,
                origin: "web",
                reason: "icar",
                id_related: payment.report.report._id,
                plate: payment.report.report.plate,
                process_info: payment.report.report.process_info
            };

            getDataPayment(newPaymentData);
            setHasCalledPayment(true);
        }
    }

    const handlePaymentProcess = () => {
        if (!payment?.dataPayment?.data?.payment_process?._id || !getPaymentProcess) return;
        getPaymentProcess(payment.dataPayment.data.payment_process._id);
    }

    const handleButtonClick = () => {
        const currentPath = location.pathname;
        const basePath = currentPath.includes('/agradecimiento/venta')
            ? currentPath.split('/agradecimiento/venta')[0]
            : '/';

        switch (basePath) {
            case '/vender-auto/detalle':
                navigate('/perfil/mis_publicaciones');
                break;
            default:
                navigate(basePath || '/');
                break;
        }

    };

    const handleOnCloseProcess = () => {
        setShowErrorModal(false);
        setShowPaymentModal(false);
        handleButtonClick()
    };

    useEffect(() => {
        if (payment?.fetching === "success") {
            setShowPaymentModal(true);
            setShowErrorModal(true);
        }
    }, [payment?.fetching]);

    useEffect(() => {
        handleGetUrl();
    }, [payment?.report?.report?._id]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className={styles.container}>
                <div className={styles.card}>
                    <img src={images.thankYouLinze} alt="Linze" title="Linze" className={styles.image} />
                    <h2 className={styles.title}>Estás a solo un paso de vender tu auto.</h2>
                    <p className={styles.text}>Estamos revisando la información de tu vehículo. Te avisaremos cuando ya esté publicado.</p>
                    <div className={styles.actions}>
                        <ButtonShared
                            onPress={handleButtonClick}
                            title="Continuar sin informe"
                            tertiary
                            className={styles.btnBack}
                            size="small"
                        />
                        <ButtonShared
                            size="small"
                            onPress={handleSubmitCarInfo}
                            title="Adquirir informe"
                            loading={isLoading}
                            primary
                            className={styles.btnPurchase}
                        />
                    </div>
                </div>
            </div>

            {showPaymentModal && (
                <ModalPayment
                    open={showErrorModal}
                    onClose={handleOnCloseProcess}
                    url={dataPayment?.data?.payment_process?.external_payment_data?.url}
                    handlePaymentProcess={handlePaymentProcess}
                    dataPayment={dataPayment?.data?.payment_process?.status}
                    user={user}
                    linkPayment={linkPayment}
                    carInfo={publication}
                    formData={formData}
                    reloadClose={true}
                />
            )}
        </>
    )
}

export default memo(CongratulationsPageSell);